<script setup lang="ts">
defineProps<{
  show: boolean
  text: string
  x: number
  y: number
  width?: string
  maxWidth?: string
  maxHeight?: string
  zIndex?: number
}>()

const emit = defineEmits<{
  (e: 'mouseenter'): void
  (e: 'mouseleave'): void
}>()

const handleMouseEnter = () => {
  emit('mouseenter')
}

const handleMouseLeave = () => {
  emit('mouseleave')
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="show && text"
      class="text-tooltip-container"
      :style="{
        left: x + 'px',
        top: y + 'px',
        width: width ? width : 'max-content',
        maxWidth: maxWidth || '480px',
        maxHeight: maxHeight || 'none',
        overflowY: maxHeight ? 'auto' : 'visible',
        pointerEvents: maxHeight ? 'auto' : 'none',
        zIndex: zIndex || 10001
      }"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @wheel.stop
    >
      {{ text }}
    </div>
  </Teleport>
</template>

<style scoped>
.text-tooltip-container {
  position: fixed;
  pointer-events: none;
  background: #1E293B;
  color: #F3F4F6;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.6;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
  border: 1px solid #475569;
  word-break: break-all;
  overflow: visible;
  white-space: pre-wrap;
}
</style>
